'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconScannerGun, iconScannerGunTag } from '@ni/nimble-components/dist/esm/icons/scanner-gun';
import { wrap } from '../../utilities/react-wrapper';

export type { IconScannerGun };
export { iconScannerGunTag };
export const NimbleIconScannerGun = wrap(IconScannerGun);